import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import styles from './AiGradientShell.module.scss';
export const AiGradientShell = (_0)=>{
    let { children, className, style, testId } = _0, rest = _object_without_properties(_0, [
        "children",
        "className",
        "style",
        "testId"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, rest), {
        className: cn(styles.shell, className),
        style: style,
        "data-testid": testId,
        children: children
    }));
};
